import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IntlPhoneInputComponent } from './intl-phone-input.component';
import { InputTextModule } from 'primeng/inputtext';

@NgModule({
  declarations: [IntlPhoneInputComponent],
  imports: [CommonModule, InputTextModule],
  exports: [IntlPhoneInputComponent]
})
export class IntlPhoneInputModule {}
